import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import QuoteForm from "@/pages/QuoteForm";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import LeadDetail from "@/pages/LeadDetail";
import Settings from "@/pages/Settings";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import VerifyEmail from "@/pages/VerifyEmail";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import AdminAccount from "@/pages/AdminAccount";
import { AdminRoute } from "@/components/AdminRoute";
import { SubscribeStart, SubscribeSuccess } from "@/pages/Subscribe";
import BillingLink from "@/pages/BillingLink";

const guard = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/q/:slug" element={<QuoteForm />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/subscribe" element={<SubscribeStart />} />
            <Route path="/billing" element={<BillingLink />} />
            <Route path="/subscribe/success" element={<SubscribeSuccess />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/dashboard" element={guard(<Dashboard />)} />
            <Route path="/admin" element={guard(<AdminRoute><Admin /></AdminRoute>)} />
            <Route path="/admin/accounts/:id" element={guard(<AdminRoute><AdminAccount /></AdminRoute>)} />
            <Route path="/leads/:id" element={guard(<LeadDetail />)} />
            <Route path="/settings" element={guard(<Settings />)} />
            <Route path="/payment/success" element={guard(<PaymentSuccess />)} />
            <Route path="/payment/cancel" element={guard(<PaymentCancel />)} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
